window.theme = window.theme || {};

theme.utils = {
    defaultTo: function(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value
    }
}

theme.Currency = (function() {
    var moneyFormat = '${{amount}}';
    var superScript = theme && theme.settings && theme.settings.superScriptPrice;
  
    function formatMoney(cents, format) {
      if (!format) {
        format = theme.settings.moneyFormat;
      }
  
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }
      var value = '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = (format || moneyFormat);
  
      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = theme.utils.defaultTo(precision, 2);
        thousands = theme.utils.defaultTo(thousands, ',');
        decimal = theme.utils.defaultTo(decimal, '.');
  
        if (isNaN(number) || number == null) {
          return 0;
        }
  
        number = (number / 100.0).toFixed(precision);
  
        var parts = number.split('.');
        var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        var centsAmount = parts[1] ? (decimal + parts[1]) : '';
  
        return dollarsAmount + centsAmount;
      }
  
      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
  
          if (superScript && value && value.includes('.')) {
            value = value.replace('.', '<sup>') + '</sup>';
          }
  
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
  
          if (superScript && value && value.includes(',')) {
            value = value.replace(',', '<sup>') + '</sup>';
          }
  
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;
      }
  
      return formatString.replace(placeholderRegex, value);
    }
  
    function getBaseUnit(variant) {
      if (!variant) {
        return;
      }
  
      if (!variant.unit_price_measurement || !variant.unit_price_measurement.reference_value) {
        return;
      }
  
      return variant.unit_price_measurement.reference_value === 1
        ? variant.unit_price_measurement.reference_unit
        : variant.unit_price_measurement.reference_value +
            variant.unit_price_measurement.reference_unit;
    }
  
    return {
      formatMoney: formatMoney,
      getBaseUnit: getBaseUnit
    }
})();

class DTFLengthInput {
  constructor(container) {
    this.container = container;
    this.input = container.querySelector('[data-dtf-length-input]');
    this.minusBtn = container.querySelector('[data-action="minus"]');
    this.plusBtn = container.querySelector('[data-action="plus"]');
    this.minimum = parseInt(container.dataset.minimum) || 1;
    this.minimumMessage = container.dataset.minimumMessage || 'Minimum order is {minimum} inches';
    
    this.init();
  }

  init() {
    if (!this.input) return;

    // Handle +/- button clicks
    this.minusBtn?.addEventListener('click', () => this.updateQuantity(-1));
    this.plusBtn?.addEventListener('click', () => this.updateQuantity(1));

    // Only validate when user leaves field (not during typing)
    this.input.addEventListener('blur', () => this.validateInput(false));

    // Sync with regular quantity selector if it exists
    this.syncWithQuantitySelector();

    // Validate on form submit (show popup if below minimum)
    this.addFormValidation();
  }

  addFormValidation() {
    // Find all product forms
    const forms = document.querySelectorAll('form[action*="/cart/add"]');
    forms.forEach(form => {
      form.addEventListener('submit', (e) => {
        const currentValue = parseInt(this.input.value) || 0;
        if (currentValue < this.minimum) {
          e.preventDefault();
          const message = this.minimumMessage.replace('{minimum}', this.minimum);
          alert(message);
          this.input.value = this.minimum;
          this.input.focus();
        }
      });
    });
  }

  updateQuantity(direction) {
    const step = parseInt(this.minusBtn.dataset.step) || 1;
    const max = parseInt(this.plusBtn.dataset.max) || 10000;
    let currentValue = parseInt(this.input.value) || this.minimum;
    let newValue = currentValue + (direction * step);

    // Enforce min/max
    newValue = Math.max(this.minimum, Math.min(max, newValue));
    
    this.input.value = newValue;
    this.input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  validateInput(showAlert = false) {
    let value = parseInt(this.input.value) || this.minimum;
    const max = parseInt(this.plusBtn.dataset.max) || 10000;

    // Enforce minimum and maximum
    if (value < this.minimum) {
      if (showAlert) {
        const message = this.minimumMessage.replace('{minimum}', this.minimum);
        alert(message);
      }
      value = this.minimum;
    } else if (value > max) {
      value = max;
    }

    this.input.value = value;
    this.syncWithQuantitySelector();
    this.notifyPriceCalculator();
  }

  syncWithQuantitySelector() {
    // Find and update the regular quantity selector's minimum
    const quantityInputs = document.querySelectorAll('input[name="quantity"]');
    quantityInputs.forEach(qtyInput => {
      qtyInput.min = this.minimum;
      if (parseInt(qtyInput.value) < this.minimum) {
        qtyInput.value = this.minimum;
        // Trigger change event so other scripts know the value changed
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
      }
    });
  }

  notifyPriceCalculator() {
    // Dispatch event for price calculator to listen to
    const event = new CustomEvent('dtf:length-changed', {
      detail: { length: parseInt(this.input.value) },
      bubbles: true
    });
    this.container.dispatchEvent(event);
  }
}

class DTFPriceCalculator {
  constructor(container) {
    this.containerId = container.id;
    var display = container.querySelector('.dtf-price__display');
    if (!display) return;

    this.basePrice = parseFloat(display.dataset.basePrice) || 0;
    this.compareAtPrice = parseFloat(display.dataset.compareAtPrice) || 0;
    this.useVariantPrice = display.dataset.useVariantPrice === 'true';

    /* Resolve the parent *section* ID so we can match variant-change events. */
    var parentSection = container.closest('[id^="shopify-section-"]');
    this.parentSectionId = parentSection
      ? parentSection.id.replace('shopify-section-', '')
      : null;

    this.regularQuantity = 1;
    this._initialized = true;
    this.init();
  }

  /* Always re-query live DOM — elements may have been replaced by section re-render */
  getElements() {
    var container = document.getElementById(this.containerId)
      || document.querySelector('.product__dtf-price');
    if (!container) return null;
    var display = container.querySelector('.dtf-price__display');
    if (!display) return null;
    return {
      display: display,
      price: display.querySelector('[data-dtf-calculated-price]'),
      compare: display.querySelector('[data-dtf-compare-price]'),
      save: display.querySelector('[data-dtf-save-percent]'),
      badge: display.querySelector('[data-dtf-sale-badge]')
    };
  }

  /* Prefer the DTF Length input, fall back to any name="quantity" */
  getLengthInput() {
    return document.querySelector('[data-dtf-length-input]')
      || document.querySelector('input[name="quantity"]');
  }

  readCurrentLength() {
    var input = this.getLengthInput();
    return input ? (parseInt(input.value) || 1) : 1;
  }

  init() {
    /* Always listen for variant changes so basePrice stays current */
    this.listenForVariantChanges();

    if (this.useVariantPrice) {
      this.updatePriceDisplay(this.basePrice, this.compareAtPrice);
    } else {
      // Calculator mode: price × length
      this.regularQuantity = this.readCurrentLength();

      var self = this;

      /* Catch changes on both the DTF Length input AND any name="quantity" */
      var quantityChangeHandler = function(e) {
        if (e.target && (e.target.hasAttribute('data-dtf-length-input') || e.target.name === 'quantity')) {
          self.regularQuantity = parseInt(e.target.value) || 1;
          self.calculatePrice();
        }
      };

      document.addEventListener('change', quantityChangeHandler);
      document.addEventListener('input', quantityChangeHandler);

      /* Listen for the custom dtf:length-changed event */
      document.addEventListener('dtf:length-changed', function(e) {
        if (e.detail && e.detail.length) {
          self.regularQuantity = e.detail.length;
          self.calculatePrice();
        }
      });

      /* +/- button clicks */
      document.addEventListener('click', function(e) {
        if (e.target.closest('.quantity__button, [name="plus"], [name="minus"], [data-action="plus"], [data-action="minus"]')) {
          setTimeout(function() {
            self.regularQuantity = self.readCurrentLength();
            self.calculatePrice();
          }, 50);
        }
      });

      this.observeQuantityChanges();
      this.calculatePrice();
    }
  }

  listenForVariantChanges() {
    /* Theme pub/sub (primary) */
    if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        /* Match against the parent section, not the block id */
        if (this.parentSectionId && event.data.sectionId !== this.parentSectionId) return;
        var variant = event.data && event.data.variant;
        if (!variant) return;

        this.basePrice = variant.price || 0;
        this.compareAtPrice = variant.compare_at_price || 0;

        if (this.useVariantPrice) {
          this.updatePriceDisplay(this.basePrice, this.compareAtPrice);
        } else {
          this.calculatePrice();
        }
      });
    }

    /* URL fallback — catches variant changes that don't fire pub/sub */
    var lastVariantId = this.getVariantIdFromUrl();
    var self = this;
    setInterval(function() {
      var currentId = self.getVariantIdFromUrl();
      if (currentId && currentId !== lastVariantId) {
        lastVariantId = currentId;
        self.fetchVariantPrice(currentId);
      }
    }, 1000);
  }

  getVariantIdFromUrl() {
    var params = new URLSearchParams(window.location.search);
    return params.get('variant');
  }

  fetchVariantPrice(variantId) {
    /* Try to find variant data from the product JSON on the page */
    var scriptTag = document.querySelector('script[data-product-json], [type="application/json"][data-product-json]');
    if (scriptTag) {
      try {
        var product = JSON.parse(scriptTag.textContent);
        var variant = product.variants.find(function(v) { return String(v.id) === String(variantId); });
        if (variant) {
          this.basePrice = variant.price || 0;
          this.compareAtPrice = variant.compare_at_price || 0;
          if (this.useVariantPrice) {
            this.updatePriceDisplay(this.basePrice, this.compareAtPrice);
          } else {
            this.calculatePrice();
          }
          return;
        }
      } catch(e) { /* ignore parse errors */ }
    }

    /* Fallback: fetch from Shopify AJAX API */
    var self = this;
    fetch(window.location.pathname + '.js')
      .then(function(r) { return r.json(); })
      .then(function(product) {
        var variant = product.variants.find(function(v) { return String(v.id) === String(variantId); });
        if (variant) {
          self.basePrice = variant.price || 0;
          self.compareAtPrice = variant.compare_at_price || 0;
          if (self.useVariantPrice) {
            self.updatePriceDisplay(self.basePrice, self.compareAtPrice);
          } else {
            self.calculatePrice();
          }
        }
      })
      .catch(function() {});
  }

  observeQuantityChanges() {
    var self = this;
    var lastQuantity = this.regularQuantity;

    setInterval(function() {
      var currentQty = self.readCurrentLength();
      if (currentQty !== lastQuantity) {
        lastQuantity = currentQty;
        self.regularQuantity = currentQty;
        self.calculatePrice();
      }
    }, 800);
  }

  calculatePrice() {
    const quantity = this.regularQuantity;

    // Base Price (in cents) × Quantity
    const calculatedPrice = this.basePrice * quantity;

    // Compare-at price × Quantity (if exists)
    const calculatedCompare = this.compareAtPrice > 0 ? this.compareAtPrice * quantity : 0;

    this.updatePriceDisplay(calculatedPrice, calculatedCompare);
  }

  updatePriceDisplay(price, compareAt) {
    /* Re-query live DOM every time — section re-renders replace elements */
    var els = this.getElements();
    if (!els || !els.price) return;

    var formatFn = (typeof theme !== 'undefined' && theme.Currency && theme.Currency.formatMoney)
      ? function(v) { return theme.Currency.formatMoney(v, theme.settings.moneyFormat); }
      : function(v) { return '$' + (v / 100).toFixed(2); };

    // Current (sale) price
    els.price.textContent = formatFn(price);

    // Compare-at (original) price
    if (els.compare) {
      if (compareAt > price) {
        els.compare.textContent = formatFn(compareAt);
        els.compare.style.display = '';
      } else {
        els.compare.style.display = 'none';
      }
    }

    // Save percentage
    if (els.save) {
      if (compareAt > price) {
        var pct = Math.round(((compareAt - price) / compareAt) * 100);
        els.save.textContent = 'Save ' + pct + '%';
        els.save.style.display = '';
      } else {
        els.save.style.display = 'none';
      }
    }

    // Sale badge visibility
    if (els.badge) {
      els.badge.style.display = (compareAt > price) ? '' : 'none';
    }

    // Toggle on-sale class
    if (els.display) {
      els.display.classList.toggle('dtf-price--on-sale', compareAt > price);
    }
  }

  formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }
}

/* ── Initialize & re-initialize after section re-renders ── */
function initDTFComponents() {
  document.querySelectorAll('.product__dtf-length').forEach(function(c) {
    if (!c._dtfLengthInit) { new DTFLengthInput(c); c._dtfLengthInit = true; }
  });
  document.querySelectorAll('.product__dtf-price').forEach(function(c) {
    if (!c._dtfPriceInit) { new DTFPriceCalculator(c); c._dtfPriceInit = true; }
  });
}

document.addEventListener('DOMContentLoaded', initDTFComponents);

/* Re-init when Shopify re-renders sections (variant changes, theme editor) */
document.addEventListener('shopify:section:load', function() { setTimeout(initDTFComponents, 100); });
document.addEventListener('shopify:section:select', function() { setTimeout(initDTFComponents, 100); });
